module.exports = "/static/assets/19c403269aab5359128779877d1d9af0.png";